import axios from "axios";
import { toast } from "react-toastify";

import {
  AUTH_ERROR,
  USER_LOADED,
  USER_LOADING,
  UPDATE_USER,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT_SUCCESS,
  LOGOUT_FAIL,
  REGISTER_SUCCESS,
  REGISTER_FAIL,
} from "./actionTypes";
import { createMessage } from "./messagesActions";
import store from "../store";
import {
  tokenConfig,
  getFormData,
  // getErrorString,
  GetErrorComponent,
} from "./helperMethods";
// eslint-disable-next-line no-unused-vars
import { DEV_URL, PROD_URL } from "constants/urls";

let url;
if (process.env.NODE_ENV === "development") url = DEV_URL;
else if (process.env.NODE_ENV === "production") url = PROD_URL;
else url = DEV_URL;
export const base_url = url;

const route = base_url + "/auth/";
const login_route = route + "login/";
const register_route = route + "register/";
const logout_route = route + "logout/";
const user_route = route + "user/";
const user_update = route + "user/update/";

const change_password = route + "change-pass/";
const reset_pass = route + "reset-pass/";
const reset_pass_confirm = route + "reset-pass/confirm/";
// TODO: valid token for reset password route

const getState = store.getState;
const dispatch = store.dispatch;
const config = {
  headers: {
    "Content-Type": "application/json",
  },
};

// LOAD USER
export const loadUser = () => {
  dispatch({ type: USER_LOADING });
  axios
    .get(user_route, tokenConfig(getState))
    .then((res) => {
      dispatch({ type: USER_LOADED, payload: res?.data });
    })
    .catch((err) => {
      dispatch({ type: AUTH_ERROR });
      dispatch(createMessage(err?.response?.data));
    });
};

// LOGIN USER
export const loginUser = (
  { email, password, keeploggedin },
  errCallback = null
) => {
  const body = JSON.stringify({ username: email, password, keeploggedin });
  axios
    .post(login_route, body, config)
    .then((res) => {
      dispatch({ type: LOGIN_SUCCESS, payload: res?.data });
      toast.success("Login success", {
        toastId: "IDloginSuccess",
        className: "myToast",
      });
    })
    .catch((err) => {
      dispatch({ type: LOGIN_FAIL });
      dispatch(createMessage(err?.response?.data));

      const msg = err.response?.data?.non_field_errors;
      msg
        ? toast.error(msg.toString(), {
            toastId: "IDloginFail",
            className: "myToast",
            autoClose: true,
          })
        : toast.error("An error occured!", {
            toastId: "IDloginError",
            className: "myToast",
          });
      errCallback?.();
    });
};

// REGISTER USER
export const registerUser = (state, onSuccess = null, onError = null) => {
  const body = JSON.stringify(state);
  axios
    .post(register_route, body, config)
    .then((res) => {
      dispatch({ type: REGISTER_SUCCESS, payload: res?.data });
      toast.success("Successfully registered!", {
        toastId: "IDregisterSuccess",
        className: "myToast",
      });
      onSuccess?.();
    })
    .catch((err) => {
      const messages = err?.response?.data;
      dispatch({ type: REGISTER_FAIL });
      dispatch(createMessage(messages));
      toast.error(
        <GetErrorComponent object={messages} altText="Registration failed!" />,
        { toastId: "IDregisterFailed" }
      );
      onError?.();
    });
};

// UPDATE USER
export const updateUser = (data, callback = null) => {
  const body = getFormData(data);
  axios
    .patch(user_update, body, tokenConfig(getState))
    .then((res) => {
      dispatch({ type: UPDATE_USER, payload: res.data });
      toast.success("Account updated successfully", {
        toastId: "IDaccountUpdateSuccess",
        className: "myToast",
      });
      callback?.();
    })
    .catch((err) => {
      dispatch(createMessage(err.response.data));
      let msg =
        err?.response?.data?.messages?.join(" ") || "Update user failed!";
      toast.error(msg, {
        toastId: "IDupdateUserFailed",
        className: "myToast",
      });
    });
};

// CHANGE PASSWORD
export const changePassword = (data, callback = null) => {
  const body = getFormData(data);
  axios
    .put(change_password, body, tokenConfig(getState))
    .then((res) => {
      toast.success("Password changed successfully", {
        toastId: "IDpassChangeSuccess",
        className: "myToast",
      });
      callback?.();
    })
    .catch((err) => {
      dispatch(createMessage(err.response.data));
      let msg =
        err?.response?.data?.messages?.join(" ") || "Change password failed!";
      toast.error(msg, { toastId: "IDchangePassFailed" });
    });
};

// LOGOUT USER
export const logoutUser = (callback = null) => {
  const isAuthenticated = getState().auth?.isAuthenticated;
  if (!isAuthenticated) return false;
  axios
    .post(logout_route, null, tokenConfig(getState))
    .then((res) => {
      callback?.();
      dispatch({ type: LOGOUT_SUCCESS });
      toast.success("Successfully logged out!", {
        toastId: "IDlogoutUser",
        className: "myToast",
      });
    })
    .catch((err) => {
      dispatch({ type: LOGOUT_FAIL });
      dispatch(createMessage(err.response.data));
      toast.error("Logout failed!", {
        toastId: "IDlogoutFail",
        className: "myToast",
      });
    });
  return true;
};

// PASSWORD RESET
export const requestPassReset = (
  email,
  callback = null,
  errCallback = null
) => {
  const body = JSON.stringify({ email });
  axios
    .post(reset_pass, body, config)
    .then((res) => {
      toast.success(`Email successfully sent to ${email}`, {
        toastId: "IDreqPassReset",
        className: "myToast",
      });
      callback?.();
    })
    .catch((err) => {
      dispatch(createMessage(err?.response?.data));
      toast.error("An error occurred", {
        toastId: "IDreqPassResetFailed",
        className: "myToast",
      });
      errCallback?.();
    });
};

export const passResetConfirm = (
  token,
  password,
  callback = null,
  errCallback = null
) => {
  const body = JSON.stringify({ token, password });
  axios
    .post(reset_pass_confirm, body, config)
    .then((res) => {
      toast.success("Password reset successfully!", {
        toastId: "IDpassResetSuccess",
        className: "myToast",
      });
      callback?.();
    })
    .catch((err) => {
      dispatch(createMessage(err?.response?.data));
      const err_msg =
        err?.response?.data?.password?.join(" ") || "An error occurred";
      toast.error(err_msg, {
        toastId: "IDpassResetFailed",
      });
      errCallback?.();
    });
};
